import React, { useState } from 'react'
import {
  RECORDING_STEPS, RECORDING_LEAD, RECORDING_TAIL,
  RECORDING_REF_LABEL, RECORDING_REF_HELP
} from '../content/recordingScreens'
import './recording.scss'

// Recording setup, as a checklist rather than instructions-then-confirmations.
//
// Each row IS its instruction and its tick — the earlier version listed three numbered
// steps and then three checkboxes restating them, so the same content was read twice.
// Three separate ticks, not one combined "I'm set up": the failure being guarded against
// is specific (recording a single tab instead of the whole screen), and it only gets
// checked if it's named on its own line.
export default function RecordingCheckStep ({ step, onAdvance, busy }) {
  const [ticked, setTicked] = useState({})
  const [ref, setRef] = useState('')

  const phase = step.phase === 'followup' ? 'followup' : 'main'
  const allTicked = RECORDING_STEPS.every(s => ticked[s.key])
  const refOk = ref.trim().length >= 3
  const canGo = allTicked && refOk && !busy

  return (
    <div className="study-card rec">
      <div className="rec__head">
        <h2 className="rec__title">Set up your recording</h2>
        <p className="rec__lead">{RECORDING_LEAD[phase]}</p>
      </div>

      <ol className="rec__list">
        {RECORDING_STEPS.map((s, i) => (
          <li key={s.key}>
            <label className={`rec__step${ticked[s.key] ? ' is-done' : ''}`}>
              <span className="rec__num">{i + 1}</span>
              <span className="rec__body">
                <span className="rec__action">{s.action}</span>
                <span className="rec__detail">{s.detail}</span>
              </span>
              <input
                type="checkbox"
                className="rec__box"
                checked={!!ticked[s.key]}
                onChange={e => setTicked(t => ({ ...t, [s.key]: e.target.checked }))}
              />
            </label>
          </li>
        ))}
      </ol>

      <div className="rec__ref">
        <label htmlFor="rec-ref">{RECORDING_REF_LABEL}</label>
        <input
          id="rec-ref"
          className="study-input"
          value={ref}
          onChange={e => setRef(e.target.value)}
          placeholder="e.g. Zoom meeting ID 812 3456 7890"
        />
        <p className="rec__help">{RECORDING_REF_HELP}</p>
      </div>

      {RECORDING_TAIL[phase] && <p className="rec__tail">{RECORDING_TAIL[phase]}</p>}

      <div className="study-actions">
        <button
          className="study-btn study-btn--primary"
          disabled={!canGo}
          onClick={() => onAdvance({
            recordingRef: ref.trim(),
            checks: RECORDING_STEPS.reduce((a, s) => ({ ...a, [s.key]: true }), {}),
            at: Date.now()
          })}
        >
          {busy ? '…' : 'Start the session'}
        </button>
        {!canGo && !busy && (
          <span className="study-hint">
            {!allTicked ? 'tick all three to continue' : 'add your recording reference'}
          </span>
        )}
      </div>
    </div>
  )
}
